import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function Testimonials() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const testimonials = [{
    name: 'Sandra',
    location: 'Nigeria',
    quote: "Guys, if you are looking for a French tutor that is knowledgeable, patient, encourages you to keep up the good work, makes the language look like a piece of cake, look no further! You've found her! She is the best I've ever met. You won't regret putting your money here, and can you believe that she is affordable? Well, there you have it! Frenchpreneur is the No. 1!",
    rating: 5
  }, {
    name: 'Femi',
    location: 'Canada',
    quote: 'Je passe le bon temps avec le professeur de compétences orales, surtout à cause de ces nouvelles questions dédiées au TCF. Merci.',
    rating: 5
  }, {
    name: 'Mrs Rachel',
    location: 'Nigeria',
    quote: 'Sincerely thanks so much for this class. All my four years studying in the university I studied just to pass which made it difficult for me to speak but just a day class made the language clearer.',
    rating: 5
  }];
  return <section id="testimonials" className="py-24 bg-gradient-to-br from-green-50 to-orange-50" data-id="element-413">
      <div className="max-w-7xl mx-auto px-6" data-id="element-414">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 50
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-415">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-416">
            Student <span className="text-green-600" data-id="element-417">Success Stories</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-418">
            Join thousands of satisfied students who have achieved their
            language goals with us
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-419">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 30
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-shadow duration-300" data-id="element-420">
              <QuoteIcon className="text-green-600 mb-4" size={32} data-id="element-421" />
              <div className="flex gap-1 mb-4" data-id="element-422">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="text-orange-400 fill-orange-400" size={20} data-id="element-423" />)}
              </div>
              <p className="text-slate-700 text-lg mb-6 italic" data-id="element-424">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-slate-200 pt-4" data-id="element-425">
                <div className="font-semibold text-slate-900 text-lg" data-id="element-426">
                  {testimonial.name}
                </div>
                <div className="text-slate-600 text-sm" data-id="element-427">
                  {testimonial.location}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}